import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

const getSample = params => {
  return null;
};
const getMessageNotificationApiFun = () => {
  
};

/* Get App Constant Data Service*/
const getAppConstantData = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.common.getAppConstantData}`,
    method: "GET",
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get App Constant Data Service*/
const getDateConstant = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.common.getDateConstant}`,
    method: "GET",
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Constant By Category Subcategory Service*/
const getConstantByCategorySubcategory = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.common.getConstantByCategorySubcategory}`,
    method: "GET",
    params:params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Check In Check Out Machine Service*/
const checkInCheckOutMachine = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.common.checkInCheckOutMachine}`,
    method: "GET",
    params:params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};



export default {
  getSample,
  getMessageNotificationApiFun,
  getAppConstantData,
  getDateConstant,
  getConstantByCategorySubcategory,
  checkInCheckOutMachine
};
